import { render, staticRenderFns } from "./flowHeader.vue?vue&type=template&id=0c2809cf&scoped=true"
import script from "./flowHeader.vue?vue&type=script&lang=js"
export * from "./flowHeader.vue?vue&type=script&lang=js"
import style0 from "./flowHeader.vue?vue&type=style&index=0&id=0c2809cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2809cf",
  null
  
)

export default component.exports